import { getAjaxData } from "../functions/ajax-get-data";
import { loaderInstanse } from "../functions/scripts/loaderInstanse";

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.js-infinite-blogs');
    if (!container) return;

    const { ajax_url, nonce } = window.ajax_params || {};
    let isLoading = false;
    let hasMore = true;

    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    container.after(sentinel);

    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !isLoading && hasMore) {
            loadNextPage();
        }
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(sentinel);

    function loadNextPage() {
        isLoading = true;
        loaderInstanse(container, true);

        // Собираем ID именно из .blogs-section__item
        const currentIds = Array.from(document.querySelectorAll('.blogs-section__item[data-id]'))
                                .map(item => item.getAttribute('data-id'))
                                .filter(Boolean);

        getAjaxData(ajax_url, 'get_blogs', {
            nonce: nonce,
            exclude: currentIds.join(',')
        }, (res) => {
            if (res.success && res.data.html.trim() !== "") {
                container.insertAdjacentHTML('beforeend', res.data.html);

                const newItems = container.querySelectorAll('.ajax-loaded:not(.is-visible)');
                newItems.forEach((item, index) => {
                    setTimeout(() => item.classList.add('is-visible'), index * 100); 
                });

                hasMore = res.data.more;
            } else {
                hasMore = false;
                observer.unobserve(sentinel);
            }

            setTimeout(() => {
                loaderInstanse(container, false);
                isLoading = false;
            }, 300);
        });
    }
});